<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/FaireTest"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Créer une session
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher par code de session"
          />
          
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                CODE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                NOMBRE DE QUESTIONS
              </th>
              
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                DATE CRÉATION
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(session, index) in sessions" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ session.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ session.count }}
              </td>
              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(session.createdAt) }}
              </td>
              <td class="shadow-none text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        :to="{ name: 'ViewSessionPage', params: { id: session.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>
                    
                    <li>
                      <router-link
                        :to="{ name: 'ViewSessionReponsePage', params: { id: session.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-list lh-1 me-8 position-relative top-1"></i>
                        Voir réponses
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'EditSessionPage', params: { id: session.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'ContinuerSessionPage', params: { id: session.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-play-button lh-1 me-8 position-relative top-1"></i>
                        Continuer Session
                      </router-link>
                    </li>
                    
                    <li>
                      <router-link
                        :to="{ name: 'ReprendreSessionPage', params: { id: session.id } }"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-reload lh-1 me-8 position-relative top-1"></i>
                        Reprendre la Session
                      </router-link>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="suppression(session.id, sessions, 'sessions', 'une session')"
                      >
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable no-undef */
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { format_date, suppression, error } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from '@/services/JwtService';
import { AxiosResponse } from 'axios';

interface ApiResponse {
  code: number;
  data: {
    data: Array<Session>;
    totalPages: number;
    totalElements: number;
    limit: number;
  };
  message: string;
}

interface Session {
  id: number;
  code: string;
  count: number;
  filiereNiveauMatiere: { id: number; titre: string } | null;
  filiereNiveauMatiereId: number;
  createdAt: Date;
  isCompleted?: boolean;
}

interface AxiosErrorResponse {
  data: {
    message: string;
  };
}

export default defineComponent({
  name: 'ListeSession',
  components: {
    PaginationComponent,
  },
  setup() {
    const router = useRouter();
    const sessions = ref<Array<Session>>([]);
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const searchTerm = ref('');

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      page.value = page_;
      getAllSessions(page_, limit_, searchTerm.value.trim());
    };

    function rechercher() {
      page.value = 1; // Remettre à la page 1 lors d'une nouvelle recherche
      getAllSessions(1, limit.value, searchTerm.value.trim());
    }

    function getAllSessions(pageNum = 1, limitNum = 10, searchCode = '') {
      // Construction de l'URL avec le paramètre "code" pour filtrer par code de session
      let url = `/sessions?page=${pageNum}&limit=${limitNum}`;
      if (searchCode) {
        url += `&code=${encodeURIComponent(searchCode)}`;
      }

      return ApiService.get(url)
        .then(({ data }: AxiosResponse<ApiResponse>) => {
          console.log("Données reçues Tadaaaa :", data);
          const result = data.data.data;
          console.log("Résultat de la requête Tadaaar:", result);
          sessions.value = result;
          totalPages.value = data.data.totalPages;
          totalElements.value = data.data.totalElements;
          console.log("Sessions extraites :", sessions.value);
          console.log("Total pages :", totalPages.value);
          console.log("Total éléments :", totalElements.value);
        })
        .catch((err: { response: AxiosErrorResponse }) => {
          console.error("Erreur lors de la récupération des sessions:", err);
          error(err.response?.data?.message || "Erreur lors de la récupération des sessions");
        });
    }

    onMounted(() => {
      getAllSessions();
    });
    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    return {
      sessions,
      checkPermission,
      format_date,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
    };
  },
});
</script>